module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("Hang On")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Domestic as")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("an empty shopping cart")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("parked on a ledge")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("above a freeway.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Artifactual as")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("an acorn barnacle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“What is the purpose of barnacles?”")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("people ask the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Barnacles are filter feeders.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They’re fish tank décor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A plaque of barnacles")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("on top of a toilet—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("this cluster")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("of brittle puckers,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("clinging")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("to its old idea,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("these craters striped")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("pale lavender")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("for some")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("unlikely eye.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-948d2186","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Chapter001.vue
// module id = 78
// module chunks = 0